// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-btn {
  line-height: 1;
}

.ant-divider-horizontal {
  margin: 0 0 24px;
}

.ant-picker {
  width: 100%;
}

.ant-input,
.ant-picker,
.ant-select.ant-select-in-form-item {
  height: 40px;
}

.ant-input-affix-wrapper {
  padding: 0 11px;
}

.ant-form-item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  display: none;
}

.ant-form-item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
  display: inline-block;
  margin-inline-start: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.ant-table-wrapper .ant-table-thead > tr > th {
  color: #1a3353;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.ant-input[disabled] {
  color: black;
}

.ant-select-selection-item {
  color: black;
}

.ant-pagination-next,
.ant-pagination-prev {
  border: 1px solid lightgray;
}

.ant-pagination .ant-pagination-options {
  display: none;
}

.ant-layout .ant-layout-sider {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
}

.iconWarning > div > div {
  border: none;
}

.iconWarning > div > div > svg {
  margin-bottom: 15px;
}

.iconFilter > div {
  width: 40px;
  height: 40px;
  margin: 0 0 0 10px;
  border-radius: 50%;
}

.iconFilterQues > div {
  width: 40px;
  height: 40px;
  margin: 0 0 10px 10px;
  border-radius: 50%;
}

.iconCopy > div > div {
  border: none;
  background: none;
}

.ant-image {
  height: 100px;
  width: 100px;
}

.ant-row {
  margin-right: 0 !important;
}

.textA2 > .ant-input {
  border-color: #ffffff;
  padding: 0px 20px;
}

.textA2 > .ant-input:focus-within {
  border-color: #ffffff;
  box-shadow: none;
}

.textA2 > .ant-input:focus {
  border-color: #ffffff;
  box-shadow: none;
}

.FormCharacter > .ant-row > div > div {
  margin-left: 28px;
  margin-right: -13px;
}

.TableAbility > .ant-table-wrapper .ant-table-thead > tr > th {
  background-color: #fec9c9;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1;
}

.TableAbility > .ant-table-wrapper table {
  border: 1px solid #e6ebf1;
  border-radius: 8px;
}

[data-rich-colors=true] [data-sonner-toast][data-type=error],
[data-rich-colors=true] [data-sonner-toast][data-type=error] [data-close-button] {
  padding: 10px;
}

[data-sonner-toast][data-type=success] {
  padding: 10px;
}

.previewImageDetail > .ant-image {
  height: 100%;
}

.previewImageDetail > .ant-image > img {
  width: 77%;
  height: auto;
  vertical-align: middle;
}

.showImageInput > div > div {
  width: 70px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/styles/customantd.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;;;EAGE,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EAKE,aAAA;AAHF;;AAMA;EAKE,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;AAPF;;AAUA;EAEE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAUA;EACE,YAAA;AAPF;;AASA;;EAEE,2BAAA;AANF;;AAQA;EACE,aAAA;AALF;;AAOA;EACE,0CAAA;EACA,gBAAA;AAJF;;AAMA;EACE,YAAA;AAHF;;AAKA;EACE,mBAAA;AAFF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AAAF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AACA;EACE,aAAA;EACA,YAAA;AAEF;;AAAA;EACE,0BAAA;AAGF;;AADA;EACE,qBAAA;EACA,iBAAA;AAIF;;AAFA;EACE,qBAAA;EACA,gBAAA;AAKF;;AAHA;EACE,qBAAA;EACA,gBAAA;AAMF;;AAJA;EACE,iBAAA;EACA,mBAAA;AAOF;;AALA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAQF;;AANA;EACE,yBAAA;EACA,kBAAA;AASF;;AAPA;;EAIE,aAAA;AAQF;;AANA;EACE,aAAA;AASF;;AAPA;EACE,YAAA;AAUF;;AARA;EACE,UAAA;EACA,YAAA;EACA,sBAAA;AAWF;;AATA;EACE,WAAA;EACA,YAAA;AAYF","sourcesContent":[".ant-btn {\n  line-height: 1;\n}\n\n.ant-divider-horizontal {\n  margin: 0 0 24px;\n}\n\n.ant-picker {\n  width: 100%;\n}\n\n.ant-input,\n.ant-picker,\n.ant-select.ant-select-in-form-item {\n  height: 40px;\n}\n\n.ant-input-affix-wrapper {\n  padding: 0 11px;\n}\n\n.ant-form-item\n  .ant-form-item-label\n  > label.ant-form-item-required:not(\n    .ant-form-item-required-mark-optional\n  )::before {\n  display: none;\n}\n\n.ant-form-item\n  .ant-form-item-label\n  > label.ant-form-item-required:not(\n    .ant-form-item-required-mark-optional\n  )::after {\n  display: inline-block;\n  margin-inline-start: 4px;\n  color: #ff4d4f;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: '*';\n}\n\n.ant-table-wrapper .ant-table-thead > tr > th {\n  // font-weight: 500;\n  color: #1a3353;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.ant-input[disabled] {\n  color: black;\n}\n.ant-select-selection-item {\n  color: black;\n}\n.ant-pagination-next,\n.ant-pagination-prev {\n  border: 1px solid lightgray;\n}\n.ant-pagination .ant-pagination-options {\n  display: none;\n}\n.ant-layout .ant-layout-sider {\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n  background: #fff;\n}\n.iconWarning > div > div {\n  border: none;\n}\n.iconWarning > div > div > svg {\n  margin-bottom: 15px;\n}\n.iconFilter > div {\n  width: 40px;\n  height: 40px;\n  margin: 0 0 0 10px;\n  border-radius: 50%;\n}\n.iconFilterQues > div {\n  width: 40px;\n  height: 40px;\n  margin: 0 0 10px 10px;\n  border-radius: 50%;\n}\n.iconCopy > div > div {\n  border: none;\n  background: none;\n}\n.ant-image {\n  height: 100px;\n  width: 100px;\n}\n.ant-row {\n  margin-right: 0 !important;\n}\n.textA2 > .ant-input {\n  border-color: #ffffff;\n  padding: 0px 20px;\n}\n.textA2 > .ant-input:focus-within {\n  border-color: #ffffff;\n  box-shadow: none;\n}\n.textA2 > .ant-input:focus {\n  border-color: #ffffff;\n  box-shadow: none;\n}\n.FormCharacter > .ant-row > div > div {\n  margin-left: 28px;\n  margin-right: -13px;\n}\n.TableAbility > .ant-table-wrapper .ant-table-thead > tr > th {\n  background-color: #fec9c9;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n.TableAbility > .ant-table-wrapper table {\n  border: 1px solid #e6ebf1;\n  border-radius: 8px;\n}\n[data-rich-colors='true'] [data-sonner-toast][data-type='error'],\n[data-rich-colors='true']\n  [data-sonner-toast][data-type='error']\n  [data-close-button] {\n  padding: 10px;\n}\n[data-sonner-toast][data-type='success'] {\n  padding: 10px;\n}\n.previewImageDetail > .ant-image {\n  height: 100%;\n}\n.previewImageDetail > .ant-image > img {\n  width: 77%;\n  height: auto;\n  vertical-align: middle;\n}\n.showImageInput > div > div {\n  width: 70px;\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
